import { trimStart } from "lodash"

export class CookieUtil {
  static async getValue(cookies: String, key: String) {
    const cookiesArray = cookies.split(';')

    for (const cookie of cookiesArray) {
      const splitedCookie = cookie.split('=')
      if (trimStart(splitedCookie[0]) === key) {
        return splitedCookie[1]
      }
    }

    return ''
  }
}